import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import ElementsPriceDetails from '../ElementsPriceDetails/ElementsPriceDetails';
import { useTheme } from '../../../../../../../theme';
import PriceItem from '../PriceItem/PriceItem';
import TotalRefund from '../TotalRefund/TotalRefund';
const Details = ({ prices, additionalPrices, className }) => {
    var _a, _b, _c;
    const { t } = useTranslation('Refund');
    const { Details: css } = useTheme('Entities').Order.ExchangeRefundPriceDetails;
    const isRetentionNotEmpty = ((_b = (_a = prices.priceDetails.retention) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.length) > 0;
    const showAdditionalPrices = (additionalPrices === null || additionalPrices === void 0 ? void 0 : additionalPrices.length) > 0;
    return (React.createElement("div", { className: cn(css.root, className) },
        React.createElement(ElementsPriceDetails, { elements: prices.priceDetails.refunded }),
        showAdditionalPrices &&
            (additionalPrices === null || additionalPrices === void 0 ? void 0 : additionalPrices.map(price => React.createElement(PriceItem, { key: price.name, name: price.name, price: price.price }))),
        React.createElement(PriceItem, { name: t('Total has been paid'), className: css.priceHeadTitle, price: prices.priceDetails.paid.sum, delimiter: "line" }),
        isRetentionNotEmpty && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: css.priceHeadTitle }, t('Retentions')),
            React.createElement(ElementsPriceDetails, { elements: prices.priceDetails.retention }))),
        ((_c = prices.priceDetails.retention) === null || _c === void 0 ? void 0 : _c.sum) && (React.createElement(PriceItem, { name: t('Non refundable sum'), className: css.priceHeadTitle, price: prices.priceDetails.retention.sum, delimiter: "line" })),
        React.createElement(TotalRefund, { className: css.totalRefund, price: prices.priceToPay })));
};
export default Details;
